import { render } from "./PurchaseHouseAnalysisReport.vue?vue&type=template&id=38d71948&scoped=true"
import script from "./PurchaseHouseAnalysisReport.vue?vue&type=script&lang=js"
export * from "./PurchaseHouseAnalysisReport.vue?vue&type=script&lang=js"

import "./PurchaseHouseAnalysisReport.vue?vue&type=style&index=0&id=38d71948&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d71948"]])

export default __exports__